import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=206cecfd&"
import script from "./alert-dialog.vue?vue&type=script&lang=ts&"
export * from "./alert-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports